import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { PROJECTS } from "@/data";

const BeforeAfter = ({ before, after }) => (
  <div className="grid grid-cols-2 gap-1">
    <div className="relative">
      <img src={before} alt="Before" className="w-full h-40 object-cover" />
      <span className="absolute top-2 left-2 rounded-md bg-black/70 backdrop-blur px-2 py-1 text-[10px] font-bold uppercase tracking-wider text-white">
        Before
      </span>
    </div>
    <div className="relative">
      <img src={after} alt="After" className="w-full h-40 object-cover" />
      <span className="absolute top-2 left-2 rounded-md bg-[#E63946] px-2 py-1 text-[10px] font-bold uppercase tracking-wider text-white">
        After
      </span>
    </div>
  </div>
);

export const Projects = () => {
  return (
    <section id="projects" data-testid="projects-section" className="relative py-20 md:py-28 surface-a overflow-hidden">
      <div className="grain absolute inset-0 opacity-[0.04] pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#E63946]">Featured Projects</p>
          <h2 className="font-heading mt-3 text-3xl sm:text-4xl font-bold tracking-tight text-steel">
            Real work, real results
          </h2>
          <p className="mt-4 text-gray-400">
            A look at recent jobs completed for our customers — see the difference quality
            workmanship makes.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {PROJECTS.map((p, idx) => (
            <motion.article
              key={p.title}
              data-testid={`project-card-${idx}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: idx * 0.06 }}
              className="rounded-2xl card-grey elev border border-white/10 overflow-hidden hover:-translate-y-1 hover:border-white/25 transition-all duration-300"
            >
              <BeforeAfter before={p.before} after={p.after} />
              <div className="p-6">
                <h3 className="font-heading text-lg font-semibold text-white">{p.title}</h3>
                <p className="mt-3 text-sm text-gray-300 leading-relaxed">{p.description}</p>
                <p className="mt-3 flex items-start gap-2 text-sm text-gray-400">
                  <ArrowRight className="w-4 h-4 text-[#22C55E] mt-0.5 shrink-0" />
                  <span><span className="text-gray-200 font-semibold">Outcome:</span> {p.outcome}</span>
                </p>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};
